export const FETCH_REGIONS = {
	dispatch: "common/fetchRegions",
	action: "fetchRegions"
};

export const SHOW_ALERT = {
	dispatch: "common/showAlert",
	action: "showAlert"
};

export const FETCH_ALL_LANGUAGES = {
	dispatch: "common/fetchAllLanguages",
	action: "fetchAllLanguages"
};

export const RESET_COMMON_MODULE = {
	dispatch: "common/resetCommonModule",
	action: "resetCommonModule"
};

export const UPDATE_PAGE_TITLE = {
	dispatch: "common/updatePageTitle",
	action: "updatePageTitle"
};

export const SET_PAGE_HEADER_LOGO = {
	dispatch: "common/setPageHeaderLogo",
	action: "setPageHeaderLogo"
};

export const USER_SIGN_IN = {
	dispatch: "auth/userSignIn",
	action: "userSignIn"
};

export const USER_FORGOT_PASSWORD_SEND_OTP = {
	dispatch: "auth/userForgotPasswordSendOtp",
	action: "userForgotPasswordSendOtp"
};

export const USER_RESET_PASSWORD = {
	dispatch: "auth/resetPassword",
	action: "resetPassword"
};

export const USER_LOG_OUT = {
	dispatch: "auth/userLogOut",
	action: "userLogOut"
};

export const FETCH_USER_DATA = {
	dispatch: "user/fetchUserData",
	action: "fetchUserData"
};

export const FETCH_POSTS = {
	dispatch: "user/fetchPosts",
	action: "fetchPosts"
};

export const RESET_USER_MODULE = {
	dispatch: "user/resetUserModule",
	action: "resetUserModule"
};

export const FETCH_REGISTRATIONS = {
	dispatch: "retail/fetchRegistrations",
	action: "fetchRegistrations"
};

export const TAKE_ACTION_ON_REGISTRATION = {
	dispatch: "retail/takeActionOnRegistration",
	action: "takeActionOnRegistration"
};

export const GET_RETAILERS_RANKLIST = {
	dispatch: "retail/getRetailersRankList",
	action: "getRetailersRankList"
};

export const RESET_RETAILERS_RANKLIST = {
	dispatch: "retail/resetRetailersRanklist",
	action: "resetRetailersRanklist"
};

export const FETCH_RETAILER_DATA = {
	dispatch: "retail/fetchRetailerData",
	action: "fetchRetailerData"
};

export const RESET_RETAIL_MODULE = {
	dispatch: "retail/resetRetailModule",
	action: "resetRetailModule"
};

export const ONBOARD_USER_REGISTRATION = {
	dispatch: "signUp/onboardUserRegistration",
	action: "onboardUserRegistration"
};

export const SEND_OTP = {
	dispatch: "signUp/sendOTP",
	action: "sendOTP"
};

export const VERIFY_OTP = {
	dispatch: "signUp/verifyOTP",
	action: "verifyOTP"
};

export const RESET_SIGNUP_MODULE = {
	dispatch: "signUp/resetSignUpModule",
	action: "resetSignUpModule"
};

export const UPLOAD_MEDIA_TO_SERVER = {
	dispatch: "uploadMedia/uploadMediaToServer",
	action: "uploadMediaToServer"
};

export const RESET_UPLOAD_MODULE = {
	dispatch: "uploadMedia/resetUploadModule",
	action: "resetUploadModule"
};

export const RESET_RETAIL_REGISTRATIONS = {
	dispatch: "retail/resetRetailRegistrations",
	action: "resetRetailRegistrations"
};

export const GENERATE_QR_CODE_PDF = {
	dispatch: "retail/generateQRCodePdf",
	action: "generateQRCodePdf"
};

export const FETCH_TRANSACTION_HISTORY = {
	dispatch: "retail/fetchTransactionHistory",
	action: "fetchTransactionHistory"
};

export const RESET_GRAB_RETAILER = {
	dispatch: "retail/resetGrabRetailer",
	action: "resetGrabRetailer"
};

export const GET_REFERRALS = {
	dispatch: "retailReferral/getReferrals",
	action: "getReferrals"
};

export const SEND_INVITE = {
	dispatch: "retailReferral/sendInvite",
	action: "sendInvite"
};

export const ADD_UPDATE_PAYMENT_DETAILS = {
	dispatch: "payment/addUpdatePaymentDetails",
	action: "addUpdatePaymentDetails"
};

export const MAKE_TRANSACTION = {
	dispatch: "payment/makeTransaction",
	action: "makeTransaction"
};

export const GET_PAYMENT_DETAILS = {
	dispatch: "payment/getPaymentDetails",
	action: "getPaymentDetails"
};

export const SEND_SMS = {
	dispatch: "payment/sendSms",
	action: "sendSms"
};

export const RESET_PAYMENT_MODULE = {
	dispatch: "payment/resetPaymentModule",
	action: "resetPaymentModule"
};

export const ACCOUNT_VERIFICATION = {
	dispatch: "payment/accountVerification",
	action: "accountVerification"
};

export const GET_WALLET_DETAILS = {
	dispatch: "payment/getWalletDetails",
	action: "getWalletDetails"
};

export const INITIATE_PAYMENT = {
	dispatch: "jeet11/initiatePayment",
	action: "initiatePayment"
};

export const CHECK_PAYMENT_STATUS = {
	dispatch: "jeet11/checkPaymentStatus",
	action: "checkPaymentStatus"
};

export const CREATE_ORDER = {
	dispatch: "jeet11/createOrder",
	action: "createOrder"
};

export const FETCH_JEET11_PARTNER_WALLET_DETAILS = {
	dispatch: "jeet11/fetchJeet11PartnerWalletDetails",
	action: "fetchJeet11PartnerWalletDetails"
};

export const FETCH_JEET11_PARTNER_TRANSACTION_HISTORY = {
	dispatch: "jeet11/fetchJeet11TransactionHistory",
	action: "fetchJeet11TransactionHistory"
};

export const FETCH_JEET11_USER_BY_PHONE = {
	dispatch: "jeet11/fetchJeet11UserDetails",
	action: "fetchJeet11UserDetails"
};

export const PAY_JEET11_USER = {
	dispatch: "jeet11/payJeet11User",
	action: "payJeet11User"
};

export const ADD_MONEY = {
	dispatch: "jeet11/addMoney",
	action: "addMoney"
};

export const JEET11_PAYMENT_SEND_OTP = {
	dispatch: "jeet11/paymentSendOTP",
	action: "paymentSendOTP"
};

export const RESET_JEET11_SEARCHED_USER = {
	dispatch: "jeet11/resetJeet11SearchedUser",
	action: "resetJeet11SearchedUser"
};

export const RESET_JEET11_MODULE = {
	dispatch: "jeet11/resetJeet11Module",
	action: "resetJeet11Module"
};

export const FETCH_JEET11_DISTRIBUTOR_RETAILER_LIST = {
	dispatch: "jeet11/distributorRetailerList",
	action: "distributorRetailerList"
};

export const FETCH_JEET11_PARTNER_RETAILER_TRANSACTION_HISTORY = {
	dispatch: "jeet11/fetchJeet11RetailerTransactionHistory",
	action: "fetchJeet11RetailerTransactionHistory"
};

export const FETCH_FINANCE_ACKNOWLEDGEMENTS = {
	dispatch: "finance/fetchFinanceAcknowledgements",
	action: "fetchFinanceAcknowledgements"
};

export const ADD_FINANCE_ACKNOWLEDGEMENTS = {
	dispatch: "finance/addFinanceAcknowledgements",
	action: "addFinanceAcknowledgements"
};

export const FETCH_ALL_DISTRIBUTOR_RETAILER_LIST = {
	dispatch: "retail/fetchAllDistributorRetailers",
	action: "fetchAllDistributorRetailers"
};

export const GENERATE_MPIN = {
	dispatch: "jeet11/generateMpin",
	action: "generateMpin"
};

export const GENERATE_MPIN_OTP = {
	dispatch: "jeet11/generateMpinOTP",
	action: "generateMpinOTP"
};

export const UPDATE_ROLES = {
	dispatch: "jeet11/updateUserRoles",
	action: "updateUserRoles"
};

export const UPDATE_MAPPING = {
	dispatch: "jeet11/updateMapping",
	action: "updateMapping"
};

export const FETCH_RETAIL_BANNERS = {
	dispatch: "jeet11/fetchBanners",
	action: "fetchBanners"
};

export const FETCH_CAPTAIN_TARGETS = {
	dispatch: "jeet11/fetchCaptainTargets",
	action: "fetchCaptainTargets"
};

export const UPLOAD_USER_STORY = {
	dispatch: "jeet11/uploadUserStory",
	action: "uploadUserStory"
};

export const FETCH_USER_STORIES = {
	dispatch: "jeet11/fetchUserStories",
	action: "fetchUserStories"
};

export const DELETE_USER_STORY = {
	dispatch: "jeet11/deleteUserStory",
	action: "deleteUserStory"
};

export const FETCH_JEET11_PARTNER_RECHARGE_HISTORY = {
	dispatch: "jeet11/fetchJeet11PartnerRechargeHistory",
	action: "fetchJeet11PartnerRechargeHistory"
};

export const RESET_JEET11_PARTNER_RECHARGE_HISTORY = {
	dispatch: "jeet11/resetJeet11PartnerRechargeHistory",
	action: "resetJeet11PartnerRechargeHistory"
};

export const SET_JEET11_USER_PROFILE = {
	dispatch: "jeet11/setJeet11UserProfile",
	action: "setJeet11UserProfile"
};

export const RESET_JEET11_USER_PROFILE = {
	dispatch: "jeet11/resetJeet11UserProfile",
	action: "resetJeet11UserProfile"
};

export const UPDATE_FIREBASE_TOKEN = {
	dispatch: "user/updateFirebaseToken",
	action: "updateFirebaseToken"
};

export const SEND_NOTIFICATION = {
	dispatch: "jeet11/sendNotification",
	action: "sendNotification"
};

export const DOWNLOAD_INVOICE = {
	dispatch: "jeet11/downloadInvoice",
	action: "downloadInvoice"
};

export const DOWNLOAD_CREDIT_NOTE = {
	dispatch: "jeet11/downloadCreditNote",
	action: "downloadCreditNote"
};

export const DOWNLOAD_GST_INVOICE = {
	dispatch: "jeet11/downloadGSTInvoice",
	action: "downloadGSTInvoice"
};

export const FETCH_JEET11_USERS_BY_RETAILER_ID = {
	dispatch: "jeet11/fetchJeet11UsersByRetailerID",
	action: "fetchJeet11UsersByRetailerID"
};

export const RESET_JEET11_USERS_BY_RETAILER_ID = {
	dispatch: "jeet11/resetJeet11UsersByRetailerID",
	action: "resetJeet11UsersByRetailerID"
};

export const FETCH_RAZORPAY_ACCOUNT_DETAILS = {
	dispatch: "jeet11/fetchRazorpayAccountDetails",
	action: "fetchRazorpayAccountDetails"
};

export const CREATE_RAZORPAY_ACCOUNT = {
	dispatch: "jeet11/createRazorpayAccount",
	action: "createRazorpayAccount"
};

export const FETCH_MONTHLY_COMMISSION = {
	dispatch: "jeet11/fetchMonthlyCommission",
	action: "fetchMonthlyCommission"
};

export const FETCH_PRODUCTS = {
	dispatch: "jeet11/fetchProducts",
	action: "fetchProducts"
};

export const TRANSFER_COINS = {
	dispatch: "jeet11/transferCoins",
	action: "transferCoins"
};

export const FETCH_TSM_LEADERBOARD = {
	dispatch: "tsm/fetchTSMLeaderboard",
	action: "fetchTSMLeaderboard"
};

export const FETCH_TSM_EARNING = {
	dispatch: "tsm/fetchTSMEarning",
	action: "fetchTSMEarning"
};

export const EDIT_TSM_NUMBER = {
	dispatch: "tsm/editTsmNumber",
	action: "editTsmNumber"
};

export const TRANSFER_COINS_FETCH_USER_DATA = {
	dispatch: "jeet11/coinTransferFetchUserData",
	action: "coinTransferFetchUserData"
};

export const TRANSFER_COINS_FETCH_USER_DATA_MOJ = {
	dispatch: "jeet11/coinTransferFetchUserDataMoj",
	action: "coinTransferFetchUserDataMoj"
};

export const FETCH_DISTRIBUTOR_COMMISION = {
	dispatch: "jeet11/fetchDistributorCommission",
	action: "fetchDistributorCommission"
};

export const FETCH_DSTR_RETAILERS_COMMISSION = {
	dispatch: "jeet11/fetchDstrRetailersCommission",
	action: "fetchDstrRetailersCommission"
};

export const FETCH_USER_MATCH_HISTORY = {
	dispatch: "jeet11/fetchUserMatchHistory",
	action: "fetchUserMatchHistory"
};

export const FETCH_USER_RECHARGE_HISTORY = {
	dispatch: "jeet11/fetchUserRechargeHistory",
	action: "fetchUserRechargeHistory"
};

export const FETCH_TSM_GMV = {
	dispatch: "tsm/fetchTsmGmv",
	action: "fetchTsmGmv"
};

export const FETCH_RETAILER_COMMISSION = {
	dispatch: "jeet11/fetchRetailerCommission",
	action: "fetchRetailerCommission"
};

export const COMMISSION_PAYOUT = {
	dispatch: "jeet11/commissionPayout",
	action: "commissionPayout"
};

export const FETCH_RETAIL_SALARY = {
	dispatch: "jeet11/fetchRetailSalary",
	action: "fetchRetailSalary"
};

export const REVERSE_TRANSACTION = {
	dispatch: "jeet11/reverseTransaction",
	action: "reverseTransaction"
};

export const UPSERT_PROMOTER_MAPPING = {
	dispatch: "jeet11/upsertPromoterMapping",
	action: "upsertPromoterMapping"
};

export const CHANGE_SALARY_STRUCTURE_SORTING = {
	dispatch: "common/changeSalaryStructureSorting",
	action: "changeSalaryStructureSorting"
};

export const FETCH_RUMMY_PARTNER_RETAILER_TRANSACTION_HISTORY = {
	dispatch: "rummy/fetchRummyRetailerTransactionHistory",
	action: "fetchRummyRetailerTransactionHistory"
};
export const TOGGLE_APP_MODE = {
	dispatch: "rummy/toggleAppMode",
	action: "toggleAppMode"
};

export const FETCH_RUMMY_PARTNER_TRANSACTION_HISTORY = {
	dispatch: "rummy/fetchRummyTransactionHistory",
	action: "fetchRummyTransactionHistory"
};

export const PAY_RUMMY_USER = {
	dispatch: "rummy/payRummyUser",
	action: "payRummyUser"
};

export const GET_RETAILER_BY_PHONE = {
	dispatch: "signUp/getRetailerByPhone",
	action: "getRetailerByPhone"
};

export const GET_RETAILER_PROFILE = {
	dispatch: "common/getRetailerProfile",
	action: "getRetailerProfile"
};

export const UPDATE_RETAILER_PROFILE = {
	dispatch: "common/updateRetailerProfile",
	action: "updateRetailerProfile"
};

export const GET_DSTR_SIGNATURE = {
	dispatch: "common/getDstrSignature",
	action: "getDstrSignature"
};

export const UPLOAD_DSTR_SIGNATURE = {
	dispatch: "common/uploadDstrSignature",
	action: "uploadDstrSignature"
};

export const GET_NON_VERIFIED_SIGNATURE = {
	dispatch: "jeet11/getNonVerifiedSignature",
	action: "getNonVerifiedSignature"
};

export const VERIFY_SIGNATURE = {
	dispatch: "jeet11/verifySignature",
	action: "verifySignature"
};

export const GET_PENDING_INVOICES = {
	dispatch: "jeet11/getPendingInvoices",
	action: "getPendingInvoices"
};

export const VERIFY_INVOICE = {
	dispatch: "jeet11/verifyInvoice",
	action: "verifyInvoice"
};

export const FETCH_TSM_TARGETS = {
	dispatch: "tsm/fetchTSMTargets",
	action: "fetchTSMTargets"
};

export const FETCH_ALL_TSM_TARGETS = {
	dispatch: "tsm/fetchAllTSMTargets",
	action: "fetchAllTSMTargets"
};

export const UPDATE_TSM_TARGETS = {
	dispatch: "tsm/updateTSMTargets",
	action: "updateTSMTargets"
};

export const UPDATE_TSM_CSV_FILEPATH = {
	dispatch: "tsm/updateTSMCsvFilepath",
	action: "updateTSMCsvFilepath"
};

export const FETCH_RETAILER_CHILD = {
	dispatch: "associates/fetchRetailerChild",
	action: "fetchRetailerChild"
};

export const FETCH_ACTIVE_EXECUTIVE_UNDER_DSTR = {
	dispatch: "retail/fetchActiveExecutiveUnderDstr",
	action: "fetchActiveExecutiveUnderDstr"
};

export const FETCH_RETAIL_SCHEMES = {
	dispatch: "jeet11/fetchRetailSchemes",
	action: "fetchRetailSchemes"
};

export const UPDATE_RETAIL_SCHEME = {
	dispatch: "retail/updateRetailScheme",
	action: "updateRetailScheme"
};

export const CREATE_RETAIL_SCHEME = {
	dispatch: "retail/createRetailScheme",
	action: "createRetailScheme"
};

export const UPLOAD_DSTR_SUPPORT_INVOICE = {
	dispatch: "retail/uploadDstrSupportInvoice",
	action: "uploadDstrSupportInvoice"
};

export const FETCH_DSTR_SUPPORT_ENTRIES = {
	dispatch: "retail/fetchDstrSupportEntries",
	action: "fetchDstrSupportEntries"
};

export const FETCH_DSTR_SUPPORT_INVOICE = {
	dispatch: "retail/fetchDstrSupportInvoice",
	action: "fetchDstrSupportInvoice"
};

export const REVIEW_DSTR_INVOICE = {
	dispatch: "retail/reviewDstrInvoice",
	action: "reviewDstrInvoice"
};

export const FETCH_DSTR_PENDING_SUPPORT_ENTRIES = {
	dispatch: "finance/fetchDstrPendingSupportEntries",
	action: "fetchDstrPendingSupportEntries"
};

export const UPLOAD_PRIMARY_DAY_FILE = {
	dispatch: "retail/uploadPrimaryDayFile",
	action: "uploadPrimaryDayFile"
};

export const FETCH_METRICS_DATA = {
	dispatch: "associates/fetchMetricsData",
	action: "fetchMetricsData"
};

export const FETCH_ALL_DSTR_TARGETS = {
	dispatch: "tsm/fetchAllDstrTargets",
	action: "fetchAllDstrTargets"
};

export const UPDATE_DSTR_CSV_FILEPATH = {
	dispatch: "tsm/updateDSTRCsvFilepath",
	action: "updateDSTRCsvFilepath"
};

export const FETCH_RETAIL_ALERTS = {
	dispatch: "tsm/fetchRetailAlerts",
	action: "fetchRetailAlerts"
};

export const ADD_RETAIL_ALERTS = {
	dispatch: "tsm/addRetailAlerts",
	action: "addRetailAlerts"
};

export const RESCHEDULE_RETAIL_ALERTS = {
	dispatch: "tsm/rescheduleAlerts",
	action: "rescheduleAlerts"
};

export const GET_USER_ACTIVE_ALERTS = {
	dispatch: "tsm/getUserActiveAlert",
	action: "getUserActiveAlert"
};

export const CHANGE_ALERT_STATUS = {
	dispatch: "tsm/changeAlertStatus",
	action: "changeAlertStatus"
};

export const FETCH_USER_METRIC_LEADERBOARDS = {
	dispatch: "tsm/getUserMetricLeaderboards",
	action: "getUserMetricLeaderboards"
};

export const FETCH_METRIC_LEADERBOARDS = {
	dispatch: "tsm/getMetricLeaderboard",
	action: "getMetricLeaderboard"
};

export const UPSERT_METRIC_LEADERBOARDS = {
	dispatch: "tsm/upsertMetricLeaderboard",
	action: "upsertMetricLeaderboard"
};

export const RETAILERS_VISIT_LIST = {
	dispatch: "tsm/retailersVisitList",
	action: "retailersVisitList"
};

export const UPDATE_RETAILER_STATUS = {
	dispatch: "tsm/updateRetailerStatus",
	action: "updateRetailerStatus"
};

export const RETAIL_VISIT = {
	dispatch: "tsm/retailVisit",
	action: "retailVisit"
};

export const GET_RETAILER_OTP = {
	dispatch: "tsm/retailerOtp",
	action: "retailerOtp"
};
export const UPDATE_EXISTING_RETAILER = {
	dispatch: "tsm/updateExistingRetailer",
	action: "updateExistingRetailer"
};
export const FETCH_ALL_RETAIL_VISITS = {
	dispatch: "tsm/allRetailVisits",
	action: "allRetailVisits"
};
export const GET_RETAILER_VISIT_HISTORY = {
	dispatch: "tsm/getRetailerVisitHistory",
	action: "getRetailerVisitHistory"
};

export const FETCH_MONTHLY_DSTR_INVOICE = {
	dispatch: "finance/fetchMonthlyDstrInvoice",
	action: "fetchMonthlyDstrInvoice"
};

export const FINANCE_BULK_APPROVAL_DSTR_INVOICE = {
	dispatch: "finance/bulkApprovalDstrInvoice",
	action: "bulkApprovalDstrInvoice"
};

export const SCHEDULE_RETAIL_VISIT = {
	dispatch: "tsm/scheduleVisit",
	action: "scheduleVisit"
};

export const FETCH_SCHEME_REWARDS = {
	dispatch: "jeet11/fetchSchemeRewards",
	action: "fetchSchemeRewards"
};

export const TRANSFER_SCHEME_REWARD_CASH = {
	dispatch: "jeet11/transferSchemeRewardCash",
	action: "transferSchemeRewardCash"
};

export const FETCH_USER_SETTINGS = {
	dispatch: "jeet11/userSettings",
	action: "userSettings"
};

export const SET_AGENCY_DATA = {
	dispatch: "agency/agencyData",
	action: "agencyData"
};
